// // import React, { useEffect, useState } from "react";
// // import "./property.css";
// // import { paths } from "../../Utility/Constants";
// // import APICall from "../../Utility/APICall";
// // import { useAuth } from "../../Utility/AuthProvider";
// // import { GetMediaURL } from "../../Utility/APICall";
// // import RentedBtn from "../../components/Buttons/RentedBtn";
// // import VacantBtn from "../../components/Buttons/VacantBtn";
// // import CircularMeter from "./CircularMeter";
// // import CustomImage from "../../Utility/CustomImage";
// // import Lottie from "lottie-react";
// // import loaderAnimation from "../../assets/animations/loader.json";
// // import { HiOutlineBuildingStorefront } from "react-icons/hi2";

// // function Property() {
// //   const { jwt } = useAuth();
// //   const [isLoading, setIsLoading] = useState(true); // Set initial loading state to true
// //   const [modifiedArr, setModifiedArr] = useState([]);
// //   const [totalUnits, setTotalUnits] = useState([]);
// //   const [rentedUnits, setRentedUnits] = useState([]);
// //   const [vacantUnits, setVacantUnits] = useState([]);
// //   const [imagelocation, setImageLocation] = useState("");
// //   const [imageUrl, setImageUrl] = useState("");
// //   const [mediaArray, setMediaArray] = useState([]);
// //   const [oneImage, setOneImage] = useState("");
// //   const [twoImage, setTwoImage] = useState("");
// //   const [threeImage, setThreeImage] = useState("");

// //   const [finalImageURLs, setFinalImageURLs] = useState([]);

// //   // const getImageFile = async (path, location, jwt, params) => {
// //   //   let final_url =
// //   //     "https://renown-backend-assignment.el.r.appspot.com" +
// //   //     path +
// //   //     "?location=" +
// //   //     location;

// //   //   if (params) {
// //   //     const paramsString = new URLSearchParams(params).toString();
// //   //     if (paramsString.length > 0) {
// //   //       final_url += "&" + paramsString;
// //   //     }
// //   //   }

// //   //   let headers = new Headers();
// //   //   headers.append("Authorization", jwt);

// //   //   try {
// //   //     const response = await fetch(final_url, {
// //   //       headers: headers,
// //   //     });

// //   //     if (!response.ok) {
// //   //       throw new Error("Network response was not ok");
// //   //     }

// //   //     const blob = await response.blob();
// //   //     const objectURL = URL.createObjectURL(blob);
// //   //     return objectURL;
// //   //     // setOneImage(objectURL)
// //   //   } catch (error) {
// //   //     console.error("Error fetching image:", error);
// //   //     return "";
// //   //   }
// //   // };

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const response = await APICall(
// //           "GET",
// //           paths.unit.fetch,
// //           undefined,
// //           undefined,
// //           jwt
// //         );

// //         let propertyArr = response.response;
// //         setTotalUnits(propertyArr);

// //         const vacantCount = propertyArr.filter(
// //           (unit) => !unit.agreement_id
// //         ).length;
// //         const rentedCount = propertyArr.filter(
// //           (unit) => unit.agreement_id
// //         ).length;

// //         setVacantUnits(vacantCount);
// //         setRentedUnits(rentedCount);

// //         if (propertyArr.length > 3) {
// //           const newArray = propertyArr.slice(0, 3);
// //           setModifiedArr(newArray);
// //         } else {
// //           setModifiedArr(propertyArr);
// //         }
// //       } catch (error) {
// //         console.error("Error fetching data:", error);
// //       } finally {
// //         setIsLoading(false); // Set loading state to false regardless of success or failure
// //       }
// //     };

// //     fetchData(); // Call fetchData function when component mounts
// //   }, []); // Empty dependency array ensures this effect runs only once when the component mounts
// //   // console.log("Total Units -", totalUnits);
// //   // console.log("Vacant Units -", vacantUnits);
// //   // console.log("Rented Units -", rentedUnits);

// //   useEffect(() => {
// //     let temp = [];
// //     modifiedArr.map((item) => {
// //       try {
// //         console.log("location item: ", item.media[0]?.location);
// //         temp.push(item.media[0]?.location);
// //       } catch (err) {
// //         console.log("error: ", err);
// //       }
// //     });
// //     setMediaArray(temp);
// //   }, [modifiedArr]);

// //   console.log("Modified Array -", modifiedArr);

// //   // useEffect(() => {
// //   //   const showImages = async () => {
// //   //     const image1 = await getImageFile(
// //   //       paths.media.download,
// //   //       mediaArray[0],
// //   //       jwt
// //   //     );
// //   //     const image2 = await getImageFile(
// //   //       paths.media.download,
// //   //       mediaArray[1],
// //   //       jwt
// //   //     );
// //   //     const image3 = await getImageFile(
// //   //       paths.media.download,
// //   //       mediaArray[2],
// //   //       jwt
// //   //     );

// //   //     setOneImage(image1);
// //   //     setTwoImage(image2);
// //   //     setThreeImage(image3);
// //   //   };

// //   //   showImages();
// //   // }, [mediaArray]);

// //   return (
// //     <div className="property">
// //       {isLoading ? (
// //         <div>
// //           <Lottie animationData={loaderAnimation} loop={true} />
// //         </div> // Render loader if loading state is true
// //       ) : (
// //         <>
// //           <div className="flex gap-2 flex-col">
// //             {modifiedArr.map((item, index) => {
// //               // Safely access the media location
// //               const mediaLocation = item.media?.[0]?.location;
// //               const imageurl =
// //                 "http://renown-backend-asssignment/192.168.1.44:5000/media/download?location=5638358357245952/user-property-media/buildings/5476269378502656/092DE0B6-DEA6-42C1-B8AF-579DA54B7A23.jpg&quality=10";
// //               // console.log("image url: ", imageurl);
// //               return (
// //                 <div
// //                   style={{
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "start",
// //                     // backgroundColor: "purple",
// //                     gap: 10,
// //                   }}
// //                   key={index}
// //                 >
// //                   {/* Fixed-size container for images */}
// //                   <div className="property-img">
// //                     {mediaLocation ? (
// //                       <CustomImage
// //                         jwt={jwt}
// //                         location={mediaLocation}
// //                         className="w-full h-full object-contain"
// //                       />
// //                     ) : (
// //                       <div className="text-gray-400 flex items-center justify-center text-3xl">
// //                         <HiOutlineBuildingStorefront />
// //                       </div>
// //                     )}
// //                   </div>
// //                   {/* <div className="property-img">
// //                     {index === 1 ? (
// //                       <img src={oneImage} />
// //                     ) : index === 2 ? (
// //                       <img src={twoImage} />
// //                     ) : (
// //                       <img src={threeImage} />
// //                     )}
// //                   </div> */}
// //                   <>
// //                     <div className="flex flex-col items-start gap-2 flex-1 px-4 py-4">
// //                       <p className="font-semibold text-sm">{item.unit_name}</p>
// //                       <p className="">{item.building_name}</p>
// //                     </div>
// //                     <div>
// //                       {item.occupancy_status === "vacant" ? (
// //                         <VacantBtn>{item.occupancy_status}</VacantBtn>
// //                       ) : (
// //                         <RentedBtn>{item.occupancy_status}</RentedBtn>
// //                       )}
// //                     </div>
// //                   </>
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </>
// //       )}
// //       <div className="graph-container">
// //         <CircularMeter
// //           totalFlats={totalUnits}
// //           rentedFlats={rentedUnits}
// //           vacantFlats={vacantUnits}
// //         />
// //       </div>
// //     </div>
// //   );
// // }

// // export default Property;

// import React, { useEffect, useState } from "react";
// // Removed property.css import
// import { paths } from "../../Utility/Constants";
// import APICall from "../../Utility/APICall";
// import { useAuth } from "../../Utility/AuthProvider";
// // Removed GetMediaURL if CustomImage handles it
// import RentedBtn from "../../components/Buttons/RentedBtn"; // Ensure path is correct
// import VacantBtn from "../../components/Buttons/VacantBtn"; // Ensure path is correct
// import CircularMeter from "./CircularMeter"; // Ensure path is correct
// import CustomImage from "../../Utility/CustomImage"; // Ensure path and component work
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import { HiOutlineBuildingStorefront } from "react-icons/hi2";

// // Rename component to Properties if preferred for consistency
// function Property() {
//   // Or function Properties()
//   const { jwt } = useAuth();
//   const [isLoading, setIsLoading] = useState(true);
//   const [displayUnits, setDisplayUnits] = useState([]); // Units to actually display (e.g., first 3)
//   const [totalUnitsCount, setTotalUnitsCount] = useState(0);
//   const [rentedUnitsCount, setRentedUnitsCount] = useState(0);
//   const [vacantUnitsCount, setVacantUnitsCount] = useState(0);
//   // Removed image state (oneImage, twoImage etc.) if CustomImage handles loading

//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true); // Start loading
//       try {
//         const response = await APICall(
//           "GET",
//           paths.unit.fetch, // Assuming this fetches all units/properties
//           undefined,
//           undefined,
//           jwt
//         );

//         const allUnits = Array.isArray(response?.response)
//           ? response.response
//           : [];
//         setTotalUnitsCount(allUnits.length);

//         const vacantCount = allUnits.filter(
//           (unit) => unit.occupancy_status === "vacant" // Use occupancy_status consistently
//         ).length;
//         const rentedCount = allUnits.length - vacantCount; // Easier calculation

//         setVacantUnitsCount(vacantCount);
//         setRentedUnitsCount(rentedCount);

//         // Set units to display (e.g., first 3)
//         setDisplayUnits(allUnits.slice(0, 3));
//       } catch (error) {
//         console.error("Error fetching property/unit data:", error);
//         // Reset counts and display array on error
//         setTotalUnitsCount(0);
//         setVacantUnitsCount(0);
//         setRentedUnitsCount(0);
//         setDisplayUnits([]);
//       } finally {
//         setIsLoading(false); // Stop loading
//       }
//     };

//     fetchData();
//   }, [jwt]);

//   console.log("Units to display:", displayUnits); // Verify the first 3 units

//   return (
//     // Removed property class, parent Dashboard provides padding/bg/shadow
//     // Using Flexbox to potentially place list and chart side-by-side on larger screens
//     <div className="flex flex-col lg:flex-row gap-6 w-full">
//       {/* Left side: List of Properties */}
//       <div className="flex-grow">
//         {" "}
//         {/* Takes available space */}
//         {isLoading ? (
//           <div className="flex justify-center items-center h-40">
//             <Lottie
//               animationData={loaderAnimation}
//               loop={true}
//               style={{ height: 80 }}
//             />
//           </div>
//         ) : displayUnits.length > 0 ? (
//           <div className="space-y-3">
//             {/* Vertical spacing for property items */}
//             {displayUnits.map((item) => {
//               const mediaLocation = item.media?.[0]?.location; // Safely access media location
//               return (
//                 <div
//                   key={item.entity_id} // Use unit's entity_id as key
//                   // Item layout: Flexbox, padding, border, hover
//                   className="flex items-center p-3 border border-gray-200 rounded-md hover:shadow-sm transition-shadow gap-3"
//                 >
//                   {/* Image Container */}
//                   <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
//                     {mediaLocation ? (
//                       <CustomImage
//                         jwt={jwt}
//                         location={mediaLocation}
//                         // Tailwind classes for the image itself
//                         className="w-full h-full object-cover"
//                         alt={`${item.unit_name} property image`}
//                       />
//                     ) : (
//                       // Placeholder icon
//                       <HiOutlineBuildingStorefront className="text-gray-400 text-3xl" />
//                     )}
//                   </div>
//                   {/* Info Section (takes remaining space) */}
//                   <div className="flex-grow text-xs md:text-sm">
//                     <p className="font-semibold text-gray-800">
//                       {item.unit_name}
//                     </p>
//                     <p className="text-gray-500">{item.building_name}</p>
//                   </div>
//                   {/* Status Button (fixed width or shrinks) */}
//                   <div className="flex-shrink-0">
//                     {item.occupancy_status === "vacant" ? (
//                       <VacantBtn>{item.occupancy_status}</VacantBtn>
//                     ) : (
//                       <RentedBtn>{item.occupancy_status}</RentedBtn>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="text-center text-gray-500 py-6">
//             No properties found.
//           </div>
//         )}
//       </div>

//       {/* Right side: Circular Meter */}
//       {/* Control visibility and size */}
//       {!isLoading &&
//         totalUnitsCount > 0 && ( // Only show chart if not loading and there are units
//           <div className="flex-shrink-0 w-full lg:w-1/3 flex justify-center items-center pt-4 lg:pt-0">
//             <CircularMeter
//               // Pass counts instead of full arrays
//               totalFlats={totalUnitsCount}
//               rentedFlats={rentedUnitsCount}
//               vacantFlats={vacantUnitsCount}
//             />
//           </div>
//         )}
//     </div>
//   );
// }

// export default Property; // Or export default Properties;

import React from "react";
import { useUnits } from "../../Contexts/UnitContext";
import RentedBtn from "../../components/Buttons/RentedBtn";
import VacantBtn from "../../components/Buttons/VacantBtn";
import CircularMeter from "./CircularMeter";
import CustomImage from "../../Utility/CustomImage";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import { useAuth } from "../../Utility/AuthProvider";

function Property() {
  const { jwt } = useAuth();
  // Get data from context instead of fetching
  const {
    allUnits,
    totalUnitsCount,
    rentedUnitsCount,
    vacantUnitsCount,
    isLoadingAllUnits,
  } = useUnits();

  // Get first 3 units to display
  const displayUnits = allUnits.slice(0, 3);

  // Don't show individual loader - let Dashboard handle loading state
  if (isLoadingAllUnits) {
    return null; // Return null instead of showing loader
  }

  return (
    <div className="flex flex-col lg:flex-row gap-6 w-full">
      {/* Left side: List of Properties */}
      <div className="flex-grow">
        {displayUnits.length > 0 ? (
          <div className="space-y-3">
            {displayUnits.map((item) => {
              const mediaLocation = item.media?.[0]?.location;
              return (
                <div
                  key={item.entity_id}
                  className="flex items-center p-3 border border-gray-200 rounded-md hover:shadow-sm transition-shadow gap-3"
                >
                  {/* Image Container */}
                  <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
                    {mediaLocation ? (
                      <CustomImage
                        jwt={jwt}
                        location={mediaLocation}
                        className="w-full h-full object-cover"
                        alt={`${item.unit_name} property image`}
                      />
                    ) : (
                      <HiOutlineBuildingStorefront className="text-gray-400 text-3xl" />
                    )}
                  </div>
                  {/* Info Section */}
                  <div className="flex-grow text-xs md:text-sm">
                    <p className="font-semibold text-gray-800">
                      {item.unit_name}
                    </p>
                    <p className="text-gray-500">{item.building_name}</p>
                  </div>
                  {/* Status Button */}
                  <div className="flex-shrink-0">
                    {item.occupancy_status === "vacant" ? (
                      <VacantBtn>{item.occupancy_status}</VacantBtn>
                    ) : (
                      <RentedBtn>{item.occupancy_status}</RentedBtn>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-6">
            No properties found.
          </div>
        )}
      </div>

      {/* Right side: Circular Meter */}
      {totalUnitsCount > 0 && (
        <div className="flex-shrink-0 w-full lg:w-1/3 flex justify-center items-center pt-4 lg:pt-0">
          <CircularMeter
            totalFlats={totalUnitsCount}
            rentedFlats={rentedUnitsCount}
            vacantFlats={vacantUnitsCount}
          />
        </div>
      )}
    </div>
  );
}

export default Property;
